
export default function addZeroToTime(time){
    return time < 10 ? "0" + time : time;
}


